import React from 'react';
export function Footer() {
  return <footer className="bg-trek-black border-t border-trek-brown/30 py-12 text-center px-4" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <h3 className="font-display text-2xl text-trek-beige/50 mb-6 tracking-widest" data-id="element-50">
          PACK TREKKING PRO
        </h3>
        <p className="text-trek-beige/40 text-sm mb-4" data-id="element-51">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-trek-beige/40 text-sm mb-8" data-id="element-52">
          Los resultados pueden variar de persona a persona. La información
          proporcionada es con fines educativos y no sustituye el consejo médico
          o profesional.
        </p>
        <div className="text-trek-beige/30 text-xs flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-53">
          <span data-id="element-54">
            &copy; {new Date().getFullYear()} Pack Trekking Pro. Todos los
            derechos reservados.
          </span>
          <span className="hidden sm:inline" data-id="element-55">•</span>
          <a href="#" className="hover:text-trek-orange transition-colors" data-id="element-56">
            Términos y Condiciones
          </a>
          <span className="hidden sm:inline" data-id="element-57">•</span>
          <a href="#" className="hover:text-trek-orange transition-colors" data-id="element-58">
            Políticas de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}